// Builds key to use in sessionStorage depending on extractedCustomerId
export function buildSessionStorageKey(customerId: string | undefined, keyBase: string): string {
    return customerId ? `${customerId}-${keyBase}` : keyBase;
}
